module.exports = __webpack_public_path__ + "img/footer-img.1643f2f.webp";